module.exports = __webpack_public_path__ + "static/media/Rajarshi.8ac9d2f6.jpeg";